import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { actions as uiActions } from '@elab/core/store/ui';
import { actions } from '@elab/core/store/wishlist';

/**
 * Component display "Remobe from wishlist" button
 *
 * @author Zhynzher Oleksandr
 *
 * @attr { String }  [product-code] - unique code of the product
 * @attr { String }  [remove-from-wishlist-label] - label for "remove from wishlist" button
 * @attr { String }  [remove-product-popup-name] - popup name that is used to confirm product removal
 *
 * HTML Structure Example
 *
 * <e2-wishlist-remove-product
 *      product-code="Product code"
 *      remove-from-wishlist-label="Label for remove from wishlist button"
 * </e2-wishlist-remove-product>
 * */

export class WishlistRemoveProduct extends SimpleLitElement {
    static get properties() {
        return {
            productCode: { type: String, attribute: 'product-code' },
            removeFromWishlistLabel: {
                type: String,
                attribute: 'remove-from-wishlist-label',
            },
            removeProductPopupName: {
                type: String,
                attribute: 'remove-product-popup-name',
            },
        };
    }

    handleRemoveFromWishlist(productCode) {
        this.dispatchEvent(
            new CustomEvent('remove-from-wishlist', {
                detail: {
                    productCode,
                    name: this.removeProductPopupName,
                },
            }),
        );
    }

    render() {
        return html`
            <button
                class="remove-from-wishlist button button--secondary no-hover"
                @click="${() => this.handleRemoveFromWishlist(this.productCode)}"
                aria-label="Remove"
            >
                <i class="remove-from-wishlist__icon"></i>
                ${this.removeFromWishlistLabel
                    ? html`
                          <span class="remove-from-wishlist__label"
                              >${this.removeFromWishlistLabel}</span
                          >
                      `
                    : ''}
            </button>
        `;
    }
}

const mapDispatchToProps = dispatch => ({
    'remove-from-wishlist': ({ detail }) => {
        if (detail.name) {
            dispatch(actions.setPendingProduct(detail.productCode));
            dispatch(uiActions.openDialog(detail));
        } else {
            dispatch(actions.removeFromWishlist(detail.productCode));
        }
    },
});

export default () =>
    customElements.define(
        'e2-wishlist-remove-product',
        connect(null, mapDispatchToProps)(WishlistRemoveProduct),
    );
